<template>
  <div>
    <v-row
      v-if="$vuetify.breakpoint.smAndDown"
      align="center">
        <v-col
          class="col-12"
          justify="start"
        >
          <h6  class="display-text-large mb-2">{{title}}</h6>
          <v-img
            :src="image"
            height="400"
          />
          <p class="mt-2">{{text}}</p>
        </v-col>
    </v-row>

    <v-row
      v-else
      align="center">
        <v-col
          v-if="left"
          class="text-center col-6"
        >
          <v-img
            :src="image"
            height="400"
          >
          </v-img>
        </v-col>
        <v-col
          class="col-6"
          justify="start"
        >
          <h6  class="display-text-large mb-2">{{title}}</h6>
          <p>{{text}}</p>
        </v-col>
        <v-col
          v-if="!left"
          class="text-center col-6"
        >
          <v-img
            :src="image"
            height="400"
          >
          </v-img>
        </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'TextImageRow',
    props: {
      title: String,
      text: String,
      image: String,
      left: Boolean,
    },
    data: () => ({
    }),
  }
</script>
